import config from "config/config";
import { getToken } from "js/formatting/getToken";

const setChatStatus = async (payload) => {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(payload),
  };

  return await fetch(`${config.REG_API_BASE_URL}/chat`, options);
};

export default setChatStatus;
